import {getCurrentDifficulty} from '@domain/pom'
import {
  DashboardPlantSectionContainer,
  DataFetchingPlaceholder,
  ReferencesLink,
  usePlantSubmissionDownload,
  usePlantUpmId,
  usePlantContext,
  QuestionStateProvider
} from '@features/pom'
import {
  PageTitle,
  PageContainer,
  buttonOnBlueSx,
  customThemeConstants,
  BackToLink
} from '@hconnect/uikit/src/lib2'
import {FileDownload} from '@mui/icons-material'
import {LoadingButton} from '@mui/lab'
import {Box, Stack} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {generatePath, useNavigate} from 'react-router'

import {ROOT} from '../common/routing'

export const DashboardPage: React.FC = () => {
  const {t} = useTranslation()
  const {data, isLoading: isLoadingPlantData} = usePlantContext()
  const plantId = usePlantUpmId()
  const navigate = useNavigate()

  const {isPending: downloadIsLoading, mutate: downloadPlantSubmissions} =
    usePlantSubmissionDownload(plantId)

  return (
    <PageContainer>
      <Box display={'flex'} justifyContent="space-between" alignItems="center">
        <Stack>
          <BackToLink
            targetName={t('navigation.backToPlantOverview')}
            target={generatePath(ROOT)}
            navigate={navigate}
          />
          <PageTitle mb={0}>{t('dashboardPage.title')}</PageTitle>
          {data?.guidanceLink && (
            <ReferencesLink guidanceLink={data.guidanceLink} color="primary.contrastText" />
          )}
        </Stack>
        <Box mb={customThemeConstants().defaultGridSpacing}>
          <LoadingButton
            variant="contained"
            onClick={() => downloadPlantSubmissions()}
            startIcon={<FileDownload />}
            loading={downloadIsLoading}
            loadingPosition={'start'}
            sx={buttonOnBlueSx}
          >
            {t('button.download')}
          </LoadingButton>
        </Box>
      </Box>
      {data ? (
        <QuestionStateProvider
          data={{activeDifficulty: getCurrentDifficulty(data.difficultySummaries)}}
        >
          <DashboardPlantSectionContainer
            sections={data.sections}
            difficultyScoreSummaries={data.difficultySummaries}
            responsible={data.responsible}
          />
        </QuestionStateProvider>
      ) : (
        <DataFetchingPlaceholder
          isLoading={isLoadingPlantData}
          errorMessage={t('errors.sectionsNotFetched')}
        />
      )}
    </PageContainer>
  )
}
